import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { currentDomain, currentPath } from '../Index';
import { usePromotionsData } from '../data/PromotionData';
import useAppPromotionTheme from '../hooks/useAppPromotionTheme';
import PromotionSkeletonDetails from '../data/PromotionSkeletonDetails';

export default function PGGlobalCash({ isLightMode }) {
    const isAppPromo = useAppPromotionTheme(isLightMode);
    const navigate = useNavigate();
    const { promotionsData, isPromotionDataReady } = usePromotionsData();
    const data = useMemo(
        () =>
            promotionsData.find(
                (promo) => promo.title === 'PGSoft Global Cash'
            ),
        [promotionsData]
    );
    const [isMobile, setIsMobile] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const loggedInState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loggedInState);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 841);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Only redirect when promotion data is ready
    // and the promotion genuinely does not exist.
    useEffect(() => {
        if (!isPromotionDataReady) return;

        if (!data) {
            navigate('/not-found', { replace: true });
        }
    }, [isPromotionDataReady, data, navigate]);

    // Show skeleton while waiting for server time.
    if (!isPromotionDataReady) {
        return <PromotionSkeletonDetails />;
    }

    // Avoid displaying incomplete promotion details
    // while redirecting to the not-found page.
    if (!data) {
        return null;
    }

    if (!data) return null;

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>PG Global Cash Tournament</title>
                <link rel="icon" href="/images/fav.webp" sizes="32x32" />
                <meta name="description" content="ddd" />
                <link rel="canonical" href={`${currentDomain}${currentPath}`} />
            </Helmet>
            <div className="promotion-page-main all-page-main-container-min-height">
                <div className="promotion-page-container main-container-global-adjusted-padding">
                    <div className="promotion-tnc-page">
                        <div className="promotion-page-breadcrumb">
                            <a
                                href={
                                    isAppPromo
                                        ? '/promotion/'.replace(
                                              '/promotion',
                                              '/app-promotion'
                                          )
                                        : '/promotion/'
                                }
                            >
                                Promotions
                            </a>{' '}
                            / <span>{data.title}</span>
                        </div>
                        <div className="promotion-tnc-banner">
                            <img
                                src={isMobile ? data.imgSrc : data.bannerSrc}
                                alt={`FGH ${data.title}`}
                            />
                        </div>
                        <div className="promotion-tnc-content">
                            <div className="promotion-tnc-info">
                                <div
                                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                                >
                                    {data.promotionMessage.text}
                                </div>
                                <h1>PG Global Cash Tournament</h1>
                                <h2>Worth PHP 3,810,000</h2>
                                <div className="promotion-tnc-period">
                                    <strong>Event Period: </strong>
                                    <ul
                                        style={{
                                            marginLeft: '10px',
                                            marginTop: '5px',
                                        }}
                                    >
                                        <li style={{ marginBottom: '5px' }}>
                                            Tournament 1:{' '}
                                            <strong>
                                                7 October 2026 – 11 October 2026
                                                (GMT +8)
                                            </strong>
                                            , 5 Days
                                        </li>
                                        <li>
                                            Tournament 2:{' '}
                                            <strong>
                                                21 October 2026 – 25 October
                                                2026 (GMT +8)
                                            </strong>
                                            , 5 Days
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="promotion-tnc-mechanic-content">
                                {!isAppPromo && (
                                    <div className="promotion-tnc-btn-wrapper">
                                        <a
                                            href="/slots/?provider=PGSOFT"
                                            className="promotion-cta-btn"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Play Now
                                        </a>
                                    </div>
                                )}
                                <strong>Selected Games </strong>
                                <ol>
                                    <li>
                                        <p>
                                            All PG Soft games{' '}
                                            <strong className="highlight">
                                                Except table games.
                                            </strong>{' '}
                                        </p>
                                    </li>
                                </ol>
                                <strong>How it works </strong>
                                <ol>
                                    <li>
                                        Play selected games during the{' '}
                                        <strong className="highlight">
                                            “Promotion Period”
                                        </strong>{' '}
                                        to participate in the tournament.
                                    </li>
                                    <li>
                                        <p>
                                            The total cash prize for{' '}
                                            <strong className="highlight">
                                                {' '}
                                                TEN{' '}
                                            </strong>{' '}
                                            tournament (30 days) is{' '}
                                            <strong className="highlight">
                                                {' '}
                                                PHP 3,810,000
                                            </strong>
                                            .
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <p>
                                                The promotion consists of{' '}
                                                <strong className="highlight">
                                                    {' '}
                                                    TEN (10){' '}
                                                </strong>{' '}
                                                tournament.
                                            </p>
                                        </p>
                                    </li>
                                </ol>
                                <div className="table-wrapper">
                                    <table className="promotion-tnc-table">
                                        <thead>
                                            <th>Tournament</th>
                                            <th>Tournament Description</th>
                                            <th>
                                                Tournament Start and End Times
                                                (GMT +3)
                                            </th>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Tournament</td>
                                                <td>Total Bet Amount</td>
                                                <td>
                                                    Every day 00:00 – next Day
                                                    23:59
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <strong> Cash Tournament </strong>
                                <p>
                                    A total DAILY cash prizes worth PHP 381,000
                                    for this tournament.
                                </p>
                                <div className="table-wrapper">
                                    <table
                                        className="promotion-tnc-table"
                                        style={{ minWidth: '0px' }}
                                    >
                                        <thead>
                                            <tr>
                                                <th rowSpan={2}>Tournament</th>
                                                <th rowSpan={2}>Ranking</th>
                                                <th colSpan={2}>
                                                    Daily Cash Prize
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>PHP</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td rowSpan={7}>1 &amp; 2</td>
                                                <td>
                                                    1<sup>st</sup>
                                                </td>
                                                <td>28,888</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    2<sup>nd</sup>
                                                </td>
                                                <td>16,888</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    3<sup>rd</sup>
                                                </td>
                                                <td>8,688</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    4<sup>th</sup> – 10
                                                    <sup>th</sup>
                                                </td>
                                                <td>4,688</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    11<sup>th</sup> – 50
                                                    <sup>th</sup>
                                                </td>
                                                <td>2,888</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    51<sup>st</sup> – 100
                                                    <sup>th</sup>
                                                </td>
                                                <td>1,788</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    101<sup>st</sup> – 200
                                                    <sup>th</sup>
                                                </td>
                                                <td>888</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="promotion-tnc-cta">
                                    <a
                                        className="promotion-cta-btn"
                                        href="https://public.pg-demo.com/events/oct/php/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        View Full T&C
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
